module.exports = __webpack_public_path__ + "img/15.67c521bb.png";